
const state = {
  deadlines: {},
  default: false,
  id: null,
  provider_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'provider_id' },
  { key: 'title' },
]

export default state
